import React from "react";

const NotFound = () => {
  return (
    <div>
      <h1 style={{ color: "red", textAlign: "center", marginTop: "150px" }}>
        This itme Not Found !
      </h1>
      <h1 style={{ color: "red", textAlign: "center" }}>404</h1>
    </div>
  );
};

export default NotFound;
